export const getProgressColor = (frac, failFrac) => {
    const score = Math.max(Math.min((Math.log2(frac / failFrac) + 1) / 2, 1), 0);
    const r = 255 * Math.min(2 - 2 * score, 1);
    const g = 255 * Math.min(2 * score, 1);
    const b = 0;
    return `rgb(${r},${g},${b})`;
};
